import {cs}                  from "../../react/chain-services";
import {fragments}           from "../../react/fragments";
import {Invoke}              from "../../react/invoke";
import {OnUnmounted}         from "../../react/on-unmounted";
import {Static2}             from "../../react/static-2";
import {last, remove1Mutate} from "../../utils/collections";

export const GlobalEventQueue = ({eventName, surCheck}) => {
    let queue = [];

    let unregister = null;
    const register = () => {
        const lis = (e) => {
            if (!surCheck(e)) {
                return;
            }
            e.stopPropagation();
            e.preventDefault();
            last(queue)(e);
        };
        window.addEventListener(eventName, lis);
        unregister = () => window.removeEventListener(eventName, lis);
    };

    const addQueue = (listener) => {
        queue.push(listener);
        if (queue.length === 1) {
            register();
        }
        return () => {
            remove1Mutate(queue, listener);
            if (queue.length === 0) {
                unregister();
            }
        }
    };

    return ({action}) => cs(
        ["cleanup", (_, next) => Static2({next})],
        ({cleanup}) => fragments(
            Invoke({
                props: action,
                fn: ({getLatestProps}) => {
                    const listener = (e) => {
                        const action = getLatestProps();
                        action?.(e);
                    };
                    const remove = addQueue(listener);
                    cleanup.set(remove);
                },
            }),
            OnUnmounted({
                action: () => cleanup.get()(),
            })
        ),
    );
};

